import React from 'react';

const label = (key) => key.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
const identities = new Set(['node_id', 'content_hash', 'navigation', 'retrieval_ref', 'reader_visibility', 'current_capability_guide_ref', 'specialization_practice_registry_ref', 'reference_base']);
const answers = /^(answer|model_answer|expected_answer|solution_steps|hint|hints)$/;

// No HTML execution or generated explanations: recursively preserve the supplied teaching values.
export const SubjectValue = ({ value, path = 'content', field = '' }) => {
  if (value === undefined || value === null || value === '') return null;
  if (typeof value !== 'object') {
    if (/^https?:\/\/\S+$/.test(String(value))) return <a data-testid={`su-resource-${path}`} href={value} target="_blank" rel="noopener noreferrer">{value}</a>;
    if (['code', 'expected_output', 'output'].includes(field)) return <pre data-testid={`su-code-${path}`}><code>{String(value)}</code></pre>;
    return <p data-testid={`su-text-${path}`} className="su-prose">{String(value)}</p>;
  }
  if (Array.isArray(value)) return <div className="su-values">{value.map((item, i) => <div key={i} className={typeof item === 'object' ? 'su-value-item' : 'su-list-item'}>{React.createElement(SubjectValue, { value: item, path: `${path}-${i}`, field })}</div>)}</div>;
  return <div className="su-values">{Object.entries(value).filter(([k]) => !identities.has(k)).map(([key, item]) => {
    if (item === null || item === '' || (Array.isArray(item) && !item.length)) return null;
    const id = `${path}-${key}`;
    const body = React.createElement(SubjectValue, { value: item, path: id, field: key });
    if (answers.test(key)) return <details className="su-disclosure" key={key} data-testid={`su-reveal-${id}`}><summary data-testid={`su-reveal-control-${id}`}>{/hint/.test(key) ? 'Show hints' : key === 'solution_steps' ? 'Show reasoning' : 'Show answer'}</summary>{body}</details>;
    if (key === 'title' || key === 'term') return <h3 key={key} data-testid={`su-heading-${id}`}>{String(item)}</h3>;
    if (key === 'url') return <React.Fragment key={key}>{body}</React.Fragment>;
    return <div key={key}>{!['explanation', 'plain_explanation', 'simple_meaning', 'meaning', 'code'].includes(key) && <h4 data-testid={`su-label-${id}`}>{label(key)}</h4>}{body}</div>;
  })}</div>;
};

const sections = [
  ['Meaning', ['simple_meaning', 'glossary']],
  ['Why it matters here', ['why_it_matters', 'objectives']],
  ['Before you start', ['prerequisites', 'environment_and_first_step']],
  ['Learn with an example', ['concept_steps', 'worked_example', 'code_examples', 'advanced_branches']],
  ['Try it yourself', ['practice']],
  ['Check your reasoning', ['common_mistakes', 'mastery_check', 'recap']],
  ['Working with AI', ['working_with_ai']],
  ['Project connection', ['role_application']],
];

export const LessonContent = ({ lesson }) => <div data-testid="su-full-lesson">
  {sections.map(([title, fields], i) => <details key={title} className="su-lesson-section" open={i < 2} data-testid={`su-section-${i}`}>
    <summary data-testid={`su-section-toggle-${i}`}>{title}</summary>
    {fields.map((key) => <SubjectValue key={key} value={lesson[key]} field={key} path={`lesson-${key}`} />)}
  </details>)}
  <details className="su-lesson-section" data-testid="su-lesson-notes"><summary data-testid="su-lesson-notes-toggle">Content notes</summary>
    <SubjectValue path="lesson-notes" value={Object.fromEntries(Object.entries(lesson).filter(([key]) => !sections.flatMap((s) => s[1]).includes(key) && !['source_ids', 'source_notes', 'verification', 'review_status', 'title'].includes(key)))} />
  </details>
</div>;